import React, { Component } from 'react'
import Divider from 'material-ui/Divider'
import { List } from 'material-ui/List'
import RiskItem from './RiskItem'
import { getRatingValues } from '../helpers/risks'

export default class RiskList extends Component {
  render() {
    const { risks, users } = this.props
    const riskArray = []
    risks.forEach(child => {
      const risk = { ...child.val(), created: new Date(child.val().created), key: child.key }
      // Get max rating from risk ratings
      riskArray.push({ ...risk, maxRating: getRatingValues(risk.ratings.map(rating => rating.likelihood * rating.consequence).reduce((a, b) => Math.max(a, b))) })
    })

    // Sort the risks based on max rating
    riskArray.sort((a, b) => b.maxRating.value - a.maxRating.value)

    const riskItems = riskArray.map(risk => <RiskItem push={this.props.push} key={risk.key} risk={risk} owner={users.child(risk.owner).val()} />)
    for (let i = riskItems.length - 1; i >= 0; i--) {
      riskItems.splice(i, 0, <Divider key={i} />)
    }

    return (
      <List>
        {riskItems}
      </List>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RiskList.js